import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import DataView from 'Components/DataView';

//Actions
import { assignedToTabRequest } from 'Redux/actions';

const AssignedTo = (props) => {
    const { currentPackage, height } = props;
    const { messages } = useIntl();
    const tableRef = useRef();
    const dispatch = useDispatch();
    const [openSearch, setOpenSearch] = useState("");

    const { loading, items } = useSelector(state => state.assignedToTabRedux)

    const [columns, setColumns] = useState([
        {
            key: "name",
            title: messages['assigned_to_name'],
            show: true,
            resize: true,
            width: 250,
            code: "assigned_to_name",
            render: (item) => {
                return <span>{item?.label}</span>
            }
        },
        {
            key: "username",
            title: messages['assigned_to_username'],
            show: true,
            resize: true,
            width: 250,
            code: "assigned_to_username",
            render: (item) => {
                return <span>{item?.username}</span>
            }
        },
        {
            key: "email",
            title: messages['assigned_to_email'],
            show: true,
            resize: true,
            width: 250,
            code: "assigned_to_email",
            render: (item) => {
                return <span>{item?.email}</span>
            }
        },
        {
            key: "entityName",
            title: messages['assigned_to_entity_name'],
            show: true,
            resize: true,
            width: 250,
            code: "assigned_to_entity_name",
            render: (item) => {
                return <span>{item?.entityName}</span>
            }
        }
    ])

    const getData = () => {
        let payload = {
            roleId: currentPackage?.id,
            projectId: currentPackage?.projectId,
            openSearch,
            limit: 2000,
            offset: 0
        }
        dispatch(assignedToTabRequest(payload))
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            getData();
        }, 500)
        return () => clearTimeout(timer);
    }, [openSearch])

    return (
        <div style={{ marginTop: 10 }}>
            <DataView
                ref={tableRef}
                columns={columns}
                name="pm-assigned-to-tab"
                exportName="assignedto"
                externalData={items || []}
                externalLoading={loading}
                noSplit
                height={height}
                hidePagination
                disableItemSelection
                onChangeSearch={setOpenSearch}
                noClear
                externalRefresh={() => getData()}
                noFilters
                onChangeColumns={(items) => setColumns(items)}
                infiniteScroll
                tableButtons={['orderColumn']}
                noSearch
                noTags
                simpleSearch
            />
        </div>
    )
}

export default AssignedTo;